import React from 'react';
import CertificationBadges from './CertificationBadges';

const Welcome = () => {
  return (
    <div className="WelcomeLearnHeader-welcome">
      <header className="fz-24 fw-b mw-100">{t('learn.welcome')}</header>
      <CertificationBadges />
    </div>
  );
};

Welcome.propTypes = {};
export default Welcome;
